import { isPermissionDenied } from "../../../../services/session/createSession";

export const LOBBY_AUTH_REQUIRED_MESSAGE =
  "Sign in required to join or create an arena. Use the account button (top right) to connect with Google or your RallyAlly ID.";

export const LOBBY_AUTH_CONNECTING_MESSAGE =
  "Connecting your session… Try again in a moment.";

/**
 * @param {string} reason
 * @param {{ retriedAuth?: boolean; spectatorLink?: boolean }} [options]
 */
export function lobbyJoinErrorMessage(reason, options = {}) {
  if (reason === "auth_required") {
    return options.retriedAuth
      ? LOBBY_AUTH_REQUIRED_MESSAGE
      : LOBBY_AUTH_CONNECTING_MESSAGE;
  }
  if (reason === "rules") {
    return "Could not verify arena access. Sign in with the account button (top right), then try again. If it still fails, the arena may need to be recreated.";
  }
  if (reason === "not_found") return "Arena not found";
  if (reason === "spectator_code_required") {
    return "This arena requires a spectator code. Ask the host for the viewer password (not the referee password).";
  }
  if (reason === "wrong_code") {
    return options.spectatorLink
      ? "Enter the spectator code for this match (or ask the referee to share an open spectator arena)."
      : "Wrong access code";
  }
  return "Could not join this arena. Try again.";
}

/**
 * @param {unknown} err
 * @param {{ hasUid?: boolean }} [options]
 */
export function lobbyCatchErrorMessage(err, options = {}) {
  const message = err instanceof Error ? err.message : String(err);
  if (!options.hasUid && isPermissionDenied(err)) {
    return LOBBY_AUTH_REQUIRED_MESSAGE;
  }
  if (
    isPermissionDenied(err) ||
    message.includes("Missing or insufficient permissions")
  ) {
    return "Could not access this arena. Sign in with the account button (top right), then try again.";
  }
  return message;
}
